import { render } from "./HygieneRecords.vue?vue&type=template&id=79e85527&scoped=true"
import script from "./HygieneRecords.vue?vue&type=script&lang=js"
export * from "./HygieneRecords.vue?vue&type=script&lang=js"

import "./HygieneRecords.vue?vue&type=style&index=0&id=79e85527&scoped=true&lang=css"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e85527"]])

export default __exports__